import * as React from 'react';
import { Component } from 'react';

import './filterBarStyles.css';

export const FilterBar = (props) => (
    <form className="FilterBar">
      <div className="FilterTitle">Filter</div>
      <div className="ContentSection PadBottom10">
        <div className="ContentSectionTitle PadTop10 PadBottom10">
          <div className="ContentSectionTitleText">Content Type</div>
        </div>
        <div className="ContentSectionContainer">
          <div id="journalCheckbox" className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="defaultCheck6"
              name="contentTypeRadioGroup"
              value="allFilter"
              checked={props.filterData.selectedContentTypeOption === "allFilter"}
              onChange={props.handleContentTypeClick}
            />
            <label className="form-check-label" htmlFor="defaultCheck6">
              All
            </label>
          </div>
          <div id="bookCheckbox" className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="defaultCheck5"
              name="contentTypeRadioGroup"
              value="bookFilter"
              checked={props.filterData.selectedContentTypeOption === "bookFilter"}
              onChange={props.handleContentTypeClick}
            />
            <label className="form-check-label" htmlFor="defaultCheck5">
              Books &amp; Reviews
            </label>
          </div>
          <div id="paperAbstractCheckbox" className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="defaultCheck7"
              name="contentTypeRadioGroup"
              value="conferencePaperFilter"
              checked={props.filterData.selectedContentTypeOption === "conferencePaperFilter"}
              onChange={props.handleContentTypeClick}
            />
            <label className="form-check-label" htmlFor="defaultCheck7">
              Paper Abstracts
            </label>
          </div>
        </div>
      </div>
      <div className={!props.filterData.conferencePaperFilter ? "" :"MeetingsSection PadBottom10"}
           hidden={!props.filterData.conferencePaperFilter}>
        <div className="MeetingsSectionTitle PadTop10 PadBottom10">
          <div className="MeetingsSectionTitleText" >Meeting Type</div>
        </div>
        <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="allMeetingRadioId"
              name="meetingTypeRadioGroup"
              value="allMeetingFilter"
              checked={props.filterData.allMeetingFilter}
              onChange={props.handleMeetingTypeClick}
              hidden={!props.filterData.conferencePaperFilter}
            />
            <label className="form-check-label" htmlFor="allMeetingRadioId"
                   hidden={!props.filterData.conferencePaperFilter}>
              All
            </label>
          </div>
        <div className="MeetingsSectionContainer">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="defaultCheck8"
              name="meetingTypeRadioGroup"
              value="annualMeetingFilter"
              checked={props.filterData.annualMeetingFilter}
              onChange={props.handleMeetingTypeClick}
              hidden={!props.filterData.conferencePaperFilter}
            />
            <label className="form-check-label" htmlFor="defaultCheck8"
                   hidden={!props.filterData.conferencePaperFilter}>
              Annual Meeting
            </label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="defaultCheck9"
              name="meetingTypeRadioGroup"
              value="internationalMeetingFilter"
              checked={props.filterData.internationalMeetingFilter}
              onChange={props.handleMeetingTypeClick}
              hidden={!props.filterData.conferencePaperFilter}
            />
            <label className="form-check-label" htmlFor="defaultCheck9"
                   hidden={!props.filterData.conferencePaperFilter}>
              International Meeting
            </label>
          </div>
        </div>
      </div>
      <div className={!props.filterData.bookFilter ? "" :"ReviewsSection PadBottom10"}
           hidden={!props.filterData.bookFilter}>
        <div className="ReviewsSectionTitle PadTop10 PadBottom10">
          <div className="ReviewsSectionTitleText">Reviews</div>
        </div>
        <div className="ReviewsSectionContainer"
             hidden={!props.filterData.bookFilter}>
          <div className="form-check">
            <input
                type="radio"
                className="form-check-input"
                id="bookRadioAll"
                checked={props.filterData.booksAll}
                onChange={() => props.onFilterClick('booksAll')}
            />
            <label className="form-check-label" htmlFor="bookRadioAll">
              All
            </label>
          </div>
          <div className="form-check">
            <input
                type="radio"
                className="form-check-input"
                id="defaultCheck10"
                checked={props.filterData.reviewedFilter}
                onChange={() => props.onFilterClick('reviewedFilter')}
            />
            <label className="form-check-label" htmlFor="defaultCheck10">
              Only Books with Reviews
            </label>
          </div>
          <div className="form-check">
            <input
                type="radio"
                className="form-check-input"
                id="defaultCheck11"
                checked={props.filterData.notReviewedFilter}
                onChange={() => props.onFilterClick('notReviewedFilter')}
            />
            <label className="form-check-label" htmlFor="defaultCheck11">
              Only Books Available for Review
            </label>
          </div>
        </div>
      </div>
      <div className="PublicationDateSection PadBottom10">
        <div className="PublicationDateTitle PadTop10 PadBottom10">
          <div className="PublicationDateTitleText">Years</div>
        </div>
        <div className="PublicationDateContainer">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="defaultCheck20"
              checked={props.filterData.twentyTwentyOneToPresent}
              onChange={() => props.onFilterClick('twentyTwentyOneToPresent')}
            />
            <label className="form-check-label" htmlFor="defaultCheck20">
              2021 - Present
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="defaultCheck1"
              checked={props.filterData.twentySixteenToTwentyTwenty}
              onChange={() => props.onFilterClick('twentySixteenToTwentyTwenty')}
            />
            <label className="form-check-label" htmlFor="defaultCheck1">
              2016 - 2020
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="defaultCheck2"
              checked={props.filterData.twentyElevenToTwentyFifteen}
              onChange={() => props.onFilterClick('twentyElevenToTwentyFifteen')}
            />
            <label className="form-check-label" htmlFor="defaultCheck2">
              2011 - 2015
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="defaultCheck3"
              checked={props.filterData.twoThousandSixToTwentyTen}
              onChange={() => props.onFilterClick('twoThousandSixToTwentyTen')}
            />
            <label className="form-check-label" htmlFor="defaultCheck3">
              2006 - 2010
            </label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="defaultCheck4"
              checked={props.filterData.twoThousandOneToTwoThousandFive}
              onChange={() => props.onFilterClick('twoThousandOneToTwoThousandFive')}
            />
            <label className="form-check-label" htmlFor="defaultCheck4">
              2001 - 2005
            </label>
          </div>
          {!props.isSeeMoreYearsHidden && <MoreYears filterData={props.filterData} isSeeMoreYearsHidden={props.isSeeMoreYearsHidden} onFilterClick={props.onFilterClick} />}
        </div>
      </div>
    </form>
);

class MoreYears extends Component {
  render() {
    return (
      <div className="ViewMore PadBottom10">
        {
          <MoreYearsDiv filterData={this.props.filterData} onFilterClick={this.props.onFilterClick} />
        }
      </div>
    )
  }
}

const MoreYearsDiv = (props) => (
  <div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="defaultCheck12"
        checked={props.filterData.ninetySixToTwoThousand}
        onChange={() => props.onFilterClick('ninetySixToTwoThousand')}
      />
      <label className="form-check-label" htmlFor="defaultCheck12">
        1996 - 2000
      </label>
    </div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="defaultCheck13"
        checked={props.filterData.ninetyOneToNinetyFive}
        onChange={() => props.onFilterClick('ninetyOneToNinetyFive')}
      />
      <label className="form-check-label" htmlFor="defaultCheck13">
        1991 - 1995
      </label>
    </div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="defaultCheck14"
        checked={props.filterData.eightySixToNinety}
        onChange={() => props.onFilterClick('eightySixToNinety')}
      />
      <label className="form-check-label" htmlFor="defaultCheck14">
        1986 - 1990
      </label>
    </div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="defaultCheck15"
        checked={props.filterData.eightyOneToEightyFive}
        onChange={() => props.onFilterClick('eightyOneToEightyFive')}
      />
      <label className="form-check-label" htmlFor="defaultCheck15">
        1981 - 1985
      </label>
    </div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="defaultCheck16"
        checked={props.filterData.seventySixToEighty}
        onChange={() => props.onFilterClick('seventySixToEighty')}
      />
      <label className="form-check-label" htmlFor="defaultCheck16">
        1976 - 1980
      </label>
    </div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="defaultCheck17"
        checked={props.filterData.seventyOneToSeventyFive}
        onChange={() => props.onFilterClick('seventyOneToSeventyFive')}
      />
      <label className="form-check-label" htmlFor="defaultCheck17">
        1971 - 1975
      </label>
    </div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="defaultCheck18"
        checked={props.filterData.uptoSeventy}
        onChange={() => props.onFilterClick('uptoSeventy')}
      />
      <label className="form-check-label" htmlFor="defaultCheck18">
        Up to 1970
      </label>
    </div>
    {/* <div className="ViewMore">
      <a onClick={() => props.showLessYears()}>See Less</a>
    </div> */}
  </div>
)